import React from "react"
import {withRouter} from "react-router-dom"
import {SortableContainer, SortableElement} from 'react-sortable-hoc'
import { fetchProjectMedias } from "../../util/project_api_util"


const SortableItem = SortableElement(({value}) => {
  return <div className="editProjectPhoto">
    <img className="galleryPhotoPropertyTourSortable" src={value.url} draggable="false"/>
  </div>
})

const SortableList = SortableContainer(({items}) => {
  return (<div className="editProjectPhotos propertyTourPhotos">
    {items.map((value, index) => (
      <SortableItem key={`item-${value.id}`} index={index} value={value}/>
    ))}
  </div>)
})

class SortableComponent extends React.Component {
  render() {
    return <SortableList
      items={this.props.data}
      onSortEnd={this.props.onSortEnd}
      axis="xy"
      distance={5}
    />
  }
}

const IMAGE_SERVICE_KEY = 0

function isImageService(service) {
  return (
    service.media_types !== "video" &&
    service.media_types !== "matterport" &&
    !service.title.toLowerCase().includes("floor plan")
  )
}

class PropertyTourEditPhotos extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hidingMode: false,
      unhidingMode: false,
      choosingCover: false,
      hideSelection: {},
      unhideSelection: {},
      loaded: false,
    }

    this.reorderPhotos = this.reorderPhotos.bind(this)
    this.applyHide = this.applyHide.bind(this)
    this.applyUnhide = this.applyUnhide.bind(this)
    this.toggleHideSelection = this.toggleHideSelection.bind(this)
    this.toggleUnhideSelection = this.toggleUnhideSelection.bind(this)
  }

  componentDidMount() {
    this.loadAllPhotos()
  }

  loadAllPhotos() {
    const { project } = this.props
    const projectId = this.props.match.params.id
    const imageServices = project.services.filter(isImageService)

    Promise.all(imageServices.map(s =>
      fetchProjectMedias(projectId, s.id).then(r => Object.values(r)[0])
    )).then(results => {
      const seen = new Set()
      const allPhotos = results.flatMap(r => [
        ...(r.sorted_medias || []),
        ...Object.values(r.hidden_medias || {}),
      ]).filter(m => {
        if (seen.has(m.id)) return false
        seen.add(m.id)
        return true
      }).sort((a, b) => {
        if (a.sort_order == null && b.sort_order == null) return a.id - b.id
        if (a.sort_order == null) return 1
        if (b.sort_order == null) return -1
        if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order
        return a.id - b.id
      })
      const allHidden = Object.assign({}, ...results.map(r => r.hidden_medias || {}))
      this.props.changeParentState({
        sorted_medias: { [IMAGE_SERVICE_KEY]: allPhotos },
        hidden_medias: { [IMAGE_SERVICE_KEY]: allHidden },
      })
      this.setState({ loaded: true })
    })
  }

  toggleHideSelection(media) {
    const hideSelection = { ...this.state.hideSelection }
    if (hideSelection[media.id]) {
      delete hideSelection[media.id]
    } else {
      hideSelection[media.id] = media
    }
    this.setState({ hideSelection })
  }

  toggleUnhideSelection(media) {
    const unhideSelection = { ...this.state.unhideSelection }
    if (unhideSelection[media.id]) {
      delete unhideSelection[media.id]
    } else {
      unhideSelection[media.id] = media
    }
    this.setState({ unhideSelection })
  }

  applyHide() {
    const medias = { ...this.props.hidden_medias, [IMAGE_SERVICE_KEY]: { ...this.props.hidden_medias[IMAGE_SERVICE_KEY] } }
    const changed_medias = { ...this.props.changed_medias }

    Object.values(this.state.hideSelection).forEach(media => {
      if (changed_medias[media.id]) {
        delete changed_medias[media.id]
      } else {
        changed_medias[media.id] = media.id
      }
      medias[IMAGE_SERVICE_KEY][media.id] = media
    })

    this.props.changeParentState({ hidden_medias: medias, changed_medias })
    this.setState({ hidingMode: false, hideSelection: {} })
  }

  applyUnhide() {
    const medias = { ...this.props.hidden_medias, [IMAGE_SERVICE_KEY]: { ...this.props.hidden_medias[IMAGE_SERVICE_KEY] } }
    const changed_medias = { ...this.props.changed_medias }

    Object.values(this.state.unhideSelection).forEach(media => {
      if (changed_medias[media.id]) {
        delete changed_medias[media.id]
      } else {
        changed_medias[media.id] = media.id
      }
      delete medias[IMAGE_SERVICE_KEY][media.id]
    })

    this.props.changeParentState({ hidden_medias: medias, changed_medias })
    this.setState({ unhidingMode: false, unhideSelection: {} })
  }

  reorderPhotos({oldIndex, newIndex}) {
    const allPhotos = [...(this.props.sorted_medias[IMAGE_SERVICE_KEY] || [])]
    const hiddenMap = this.props.hidden_medias[IMAGE_SERVICE_KEY] || {}
    const visibleMedia = allPhotos.filter(m => !hiddenMap[m.id])

    const movedItem = visibleMedia[oldIndex]
    const targetItem = visibleMedia[newIndex]
    const fullOldIndex = allPhotos.findIndex(p => p.id === movedItem.id)
    const fullNewIndex = allPhotos.findIndex(p => p.id === targetItem.id)

    allPhotos.splice(fullOldIndex, 1)
    allPhotos.splice(fullNewIndex, 0, movedItem)

    this.props.changeParentState({ sorted_medias: { ...this.props.sorted_medias, [IMAGE_SERVICE_KEY]: allPhotos } })
  }

  render() {
    const { project } = this.props
    if (!project) return <div/>

    const { hidingMode, unhidingMode, choosingCover, hideSelection, unhideSelection, loaded } = this.state

    const allPhotos = this.props.sorted_medias[IMAGE_SERVICE_KEY] || []
    const hiddenMap = this.props.hidden_medias[IMAGE_SERVICE_KEY] || {}

    const visibleMedia = allPhotos.filter(m => !hiddenMap[m.id])
    const hiddenMediaList = Object.values(hiddenMap)

    if (!loaded) return <div className="propertyTourSortHint">Loading photos…</div>

    const activeMode = hidingMode ? "hide" : unhidingMode ? "unhide" : choosingCover ? "cover" : null

    const hintText = {
      hide: "Select the images you want to hide, then click Apply.",
      unhide: "Select the images you want to make visible again, then click Apply.",
      cover: "Click an image to set it as the cover photo.",
      null: "Drag and drop to sort images.",
    }[activeMode]

    return <div className="propertyTourEditPhotos" style={{marginTop: 0}}>

      <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
        <span className="propertyTourSortHint">{hintText}</span>
        <div className="d-flex gap-2 flex-shrink-0">
          {!choosingCover && !unhidingMode && (
            hidingMode ? (
              <>
                <button className="projectEditButton projectEditButtonLight" onClick={() => this.setState({ hidingMode: false, hideSelection: {} })}>
                  Cancel
                </button>
                <button className="projectEditButton projectEditButtonPrimary" onClick={this.applyHide}>
                  Apply
                </button>
              </>
            ) : (
              <button className="projectEditButton projectEditButtonLight" onClick={() => this.setState({ hidingMode: true })}>
                Hide Images
              </button>
            )
          )}
          {!choosingCover && !hidingMode && hiddenMediaList.length > 0 && (
            unhidingMode ? (
              <>
                <button className="projectEditButton projectEditButtonLight" onClick={() => this.setState({ unhidingMode: false, unhideSelection: {} })}>
                  Cancel
                </button>
                <button className="projectEditButton projectEditButtonPrimary" onClick={this.applyUnhide}>
                  Apply
                </button>
              </>
            ) : (
              <button className="projectEditButton projectEditButtonLight" onClick={() => this.setState({ unhidingMode: true })}>
                Unhide Images
              </button>
            )
          )}
          {!hidingMode && !unhidingMode && (
            <>
              {choosingCover && (
                <button
                  className="projectEditButton projectEditButtonLight"
                  onClick={() => {
                    this.props.onCoverReset()
                    this.setState({ choosingCover: false })
                  }}
                >
                  Cancel
                </button>
              )}
              <button
                className={`projectEditButton ${choosingCover ? 'projectEditButtonPrimary' : 'projectEditButtonLight'}`}
                onClick={() => this.setState({ choosingCover: !choosingCover })}
              >
                {choosingCover ? "Apply" : "Choose Cover"}
              </button>
            </>
          )}
        </div>
      </div>

      {activeMode === "hide" && (
        <div>
          <div className="editProjectPhotos propertyTourPhotos">
            {visibleMedia.map(media => (
              <div
                key={media.id}
                className={`editProjectPhoto propertyTourSelectablePhoto${hideSelection[media.id] ? ' propertyTourPhotoSelected' : ''}`}
                onClick={() => this.toggleHideSelection(media)}
                style={{cursor: 'pointer'}}
              >
                <img src={media.url} draggable="false"/>
                {hideSelection[media.id] && <div className="propertyTourPhotoCheckmark"><i className="fas fa-check"/></div>}
              </div>
            ))}
          </div>
        </div>
      )}

      {activeMode === "unhide" && (
        <div>
          <div className="editProjectPhotos propertyTourPhotos">
            {hiddenMediaList.map(media => (
              <div
                key={media.id}
                className={`editProjectPhoto propertyTourPhotoHidden propertyTourSelectablePhoto${unhideSelection[media.id] ? ' propertyTourPhotoSelected' : ''}`}
                onClick={() => this.toggleUnhideSelection(media)}
                style={{cursor: 'pointer'}}
              >
                <img src={media.url} draggable="false"/>
                {unhideSelection[media.id] && <div className="propertyTourPhotoCheckmark"><i className="fas fa-check"/></div>}
              </div>
            ))}
          </div>
        </div>
      )}

      {activeMode === "cover" && (
        <div>
          <div className="editProjectPhotos propertyTourPhotos">
            {visibleMedia.map(media => (
              <div
                key={media.id}
                className={`editProjectPhoto ${this.props.currentCoverSrc === media.highend_url ? 'propertyTourCoverSelected' : ''}`}
                onClick={() => this.props.onCoverSelected(media.highend_url)}
                style={{cursor: 'pointer'}}
              >
                <img src={media.url} draggable="false"/>
              </div>
            ))}
          </div>
          {this.props.currentCoverSrc && (
            <div className="mt-3">
              <div className="propertyTourSortHint">Current cover:</div>
              <img src={this.props.currentCoverSrc} style={{height: '80px', borderRadius: '4px', objectFit: 'cover'}}/>
            </div>
          )}
        </div>
      )}

      {!activeMode && visibleMedia.length > 0 && <>
        <SortableComponent
          data={visibleMedia}
          onSortEnd={this.reorderPhotos}
        />
      </>}
    </div>
  }
}

export default withRouter(PropertyTourEditPhotos)
